import PropTypes from 'prop-types';
import { Inbox } from 'lucide-react';
import Button from './Button';
import './EmptyState.css';

export default function EmptyState({
    icon: Icon = Inbox,
    title = 'No data',
    description,
    action,
    actionLabel,
    onAction,
    className = ''
}) {
    return (
        <div className={`empty-state ${className}`}>
            <div className="empty-state-icon">
                <Icon size={48} />
            </div>
            <h3 className="empty-state-title">{title}</h3>
            {description && <p className="empty-state-description">{description}</p>}
            {action || (actionLabel && onAction) ? (
                <div className="empty-state-action">
                    {action || <Button onClick={onAction}>{actionLabel}</Button>}
                </div>
            ) : null}
        </div>
    );
}

EmptyState.propTypes = {
    icon: PropTypes.elementType,
    title: PropTypes.string,
    description: PropTypes.string,
    action: PropTypes.node,
    actionLabel: PropTypes.string,
    onAction: PropTypes.func,
    className: PropTypes.string
};
